import {getQuery, removeQuery, postQuery} from "@/modules/common/utils";
import httpServiceV3 from "@/modules/common/services/httpServiceV3";

// Legacy v1 notes API — used while the rollout.clients.new_notes flag is OFF.
//
// TODO: (VCITA2-14470 — rollout.clients.new_notes cleanup): once the flag is released to all users,
// remove the v1 methods below (list, remove, add, get) and their callers:
//   - mattersStore loadNotes/removeNote: drop the v1 else-branches (keep the v3 path,
//     and listV3/removeV3 can be renamed back to list/remove)
//   - NewNoteDialog.vue + NotePage.vue + the /note/ route + the Angular openLegacyDialog
//     branch — add/clone are then served by the POV note modal (its own v3 notesService),
//     so `add` and `get` here have no replacement; they are simply deleted.
const baseUrl = 'business/clients/v1/matters';

const list = (matterUid, params) => getQuery(`${baseUrl}/${matterUid}/notes`, Object.assign(params, {new_api: true}));

const remove = (matterUid, noteUid) => removeQuery(`${baseUrl}/${matterUid}/notes/${noteUid}`, {new_api: true});

const add = (matterUid, note) => postQuery(`${baseUrl}/${matterUid}/notes`, {note, new_api: true});

const get = (matterUid, noteUid) => getQuery(`${baseUrl}/${matterUid}/notes/${noteUid}`, {new_api: true});

// v3 client_notes API — used when rollout.clients.new_notes is ON. Routed through the API
// gateway via httpServiceV3 (base = VUE_APP_API_URL_GATEWAY + '/v3/'), the same client the
// note-summary polling uses. Returns the v3 payload as-is (flat entity_*, can_edit/can_delete).
const listV3 = (matterUid, params = {}) => httpServiceV3.get('clients/client_notes', {matter_uid: matterUid, ...params});

const removeV3 = (noteUid) => httpServiceV3.remove(`clients/client_notes/${noteUid}`);

export default {
  list,
  remove,
  add,
  get,
  listV3,
  removeV3,
}
